<template>
  <div class="author-row" :class="profileType ? 'platform-' + profileType : ''">
    <div class="author-main">
      <div class="source-wrap">
        <img v-if="profileType === 'facebook'" class="source-img" src="./../../../assets/platforms/facebook.png"/>
        <img v-if="profileType === 'instagram'" class="source-img" src="./../../../assets/platforms/instagram.png"/>
        <img v-if="profileType === 'twitter'" class="source-img" src="./../../../assets/platforms/twitter.png"/>
        <img v-if="profileType === 'tiktok'" class="source-img" src="./../../../assets/platforms/tiktok.png"/>
        <img v-if="profileType === 'twitch'" class="source-img" src="./../../../assets/platforms/twitch.png"/>
        <img v-if="profileType === 'youtube'" class="source-img" src="./../../../assets/platforms/youtube.png"/>
        <span v-if="!profileType" class="source-fallback">?</span>
      </div>
      <div class="author-info">
        <span class="platform-label" v-if="profileType">{{ profileType }}</span>
        <a class="author-url" v-bind:href="data.url" target="_blank">{{ data.url }}</a>
      </div>
    </div>
    <button class="remove-btn" @click="removeAuthor" title="Remove profile">
      <i class="bi bi-trash3" aria-hidden="true"></i>
    </button>
  </div>
</template>

<script>
  import { detectPlatformHint } from '../../../utils/socialChannels';

  export default {
    name: "author",
    props: ["data", "idx"],
    data() {
      return {
        profileType: ''
      }
    },
    methods: {
      removeAuthor() {
        this.$emit('removeAuthor', {
          idx: this.idx
        });
      },
      checkType() {
        if (this.data.url !== undefined) {
          const u = this.data.url.toLowerCase();
          const hint = detectPlatformHint(u);
          if (hint) {
            this.profileType = hint;
          } else if (u.includes('twitter') || u.includes('x.com')) {
            this.profileType = 'twitter';
          }
        }
      }
    },
    created: function() {
      this.checkType();
    }
  }
</script>

<style scoped>
  .author-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 10px 12px;
    border: 1px solid #e5e7eb;
    border-radius: 10px;
    background: #fff;
    transition: border-color 0.15s, box-shadow 0.15s, transform 0.1s;
  }
  .author-row + .author-row {
    margin-top: 8px;
  }
  .author-row:hover {
    border-color: #265a88;
    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);
  }
  .author-main {
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
    min-width: 0;
  }
  .source-wrap {
    width: 36px;
    height: 36px;
    border-radius: 9px;
    background: #f3f4f6;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
  .source-img {
    width: 24px;
    height: 24px;
  }
  .source-fallback {
    color: #6b7280;
    font-weight: 600;
    font-size: 14px;
  }
  .author-info {
    display: flex;
    flex-direction: column;
    min-width: 0;
  }
  .platform-label {
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: #6b7280;
    line-height: 1.2;
  }
  .author-url {
    font-size: 13.5px;
    color: #265a88;
    text-decoration: none;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .author-url:hover {
    text-decoration: underline;
  }

  .platform-instagram .platform-label { color: #e1306c; }
  .platform-tiktok .platform-label { color: #111; }
  .platform-youtube .platform-label { color: #ff0000; }
  .platform-facebook .platform-label { color: #1877f2; }
  .platform-twitter .platform-label { color: #1da1f2; }
  .platform-twitch .platform-label { color: #9146ff; }

  .remove-btn {
    background: transparent;
    border: 1px solid transparent;
    color: #6b7280;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    flex-shrink: 0;
    transition: background 0.15s, color 0.15s, border-color 0.15s;
  }
  .remove-btn:hover {
    background: #fef2f2;
    color: #dc2626;
    border-color: #fecaca;
  }
</style>



// WEBPACK FOOTER //
// src/components/influencer/author/Author.vue